<div class="dialog-wrapper" [formGroup]="form">

  <button class="close-btn" type="button" (click)="cancel()" aria-label="Cerrar">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6L18 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="titulo">
    <img src="assets/agricola/action-update-client.svg" class="titulo-mask" alt="" aria-hidden="true">
    <div class="titulo-texto">
      <h2 class="titulo-copy">Datos personales</h2>
      <p class="titulo-sub">Actualiza la información del cliente</p>
    </div>
  </div>

  <div class="fields">

    <!-- Tipología | Subtipología -->
    <div class="linea">
      <div class="field-col">
        <app-sis-select
          label="Tipología *"
          placeholder="Selecciona"
          [options]="$any(typologyOptions)"
          formControlName="typologyId">
        </app-sis-select>
      </div>
      <div class="field-col">
        <app-sis-select
          label="Subtipología *"
          placeholder="Selecciona"
          [options]="$any(subtypologyOptions)"
          formControlName="subtypologyId">
        </app-sis-select>
      </div>
    </div>

    <!-- Primer nombre | Segundo nombre -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Primer nombre *" formControlName="firstName"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-field label="Segundo nombre" formControlName="middleName"></app-sis-field>
      </div>
    </div>

    <!-- Primer apellido | Segundo apellido -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Primer apellido *" formControlName="lastName"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-field label="Segundo apellido" formControlName="lastName2"></app-sis-field>
      </div>
    </div>

    <!-- Apellido de casado | Fecha de nacimiento -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Apellido de casado" formControlName="marriedName"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-date-field label="Fecha de nacimiento *" formControlName="birthday"></app-sis-date-field>
      </div>
    </div>

    <!-- Género | Estado civil -->
    <div class="linea">
      <div class="field-col">
        <app-sis-select
          label="Género *"
          placeholder="Selecciona"
          [options]="$any(genderOptions)"
          formControlName="gender">
        </app-sis-select>
      </div>
      <div class="field-col">
        <app-sis-select
          label="Estado civil *"
          placeholder="Selecciona"
          [options]="$any(relationshipStatusOptions)"
          formControlName="relationshipStatus">
        </app-sis-select>
      </div>
    </div>

    <!-- Identificación | Celular -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Identificación *" formControlName="nationalId"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-field label="Celular *" formControlName="mobile"></app-sis-field>
      </div>
    </div>

    <!-- Teléfono 1 | Teléfono 2 -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Teléfono 1 *" formControlName="phone1"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-field label="Teléfono 2" formControlName="phone2"></app-sis-field>
      </div>
    </div>

    <!-- Tiene correo electrónico | Correo electrónico -->
    <div class="linea linea--vcenter">
      <div class="field-col checkbox-col">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="existEmail" class="checkbox-input">
          <span>Tiene correo electrónico</span>
        </label>
      </div>
      <div class="field-col">
        <app-sis-field label="Correo electrónico *" formControlName="email"></app-sis-field>
      </div>
    </div>

    <!-- Clasificación del cliente | Dirección -->
    <div class="linea">
      <div class="field-col">
        <app-sis-select
          label="Clasificación del cliente"
          placeholder="Selecciona"
          [options]="$any(memberClassificationOptions)"
          formControlName="memberClassification">
        </app-sis-select>
      </div>
      <div class="field-col">
        <app-sis-field label="Dirección" formControlName="address"></app-sis-field>
      </div>
    </div>

    <!-- Estado | Distrito -->
    <div class="linea">
      <div class="field-col">
        <app-sis-select
          label="Estado"
          placeholder="Selecciona"
          [options]="stateOptions"
          formControlName="stateId">
        </app-sis-select>
      </div>
      <div class="field-col">
        <app-sis-select
          label="Distrito"
          placeholder="Selecciona"
          [options]="districtOptions"
          formControlName="stateDistrictId">
        </app-sis-select>
      </div>
    </div>

    <!-- Número tributario | Agencia -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Número tributario" formControlName="taxNumber"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-select
          label="Agencia"
          placeholder="Selecciona"
          [options]="agencyOptions"
          formControlName="agencyCode">
        </app-sis-select>
      </div>
    </div>

    <!-- Notas (ancho completo, textarea) -->
    <div class="field-full field-textarea">
      <span class="textarea-label">Notas *</span>
      <textarea class="notes-input" formControlName="notes" placeholder="máx. 300 caracteres" rows="3"></textarea>
    </div>

  </div>

  <div class="cta-group">
    <button class="cta cta--outline" type="button" (click)="cancel()">Cancelar</button>
    <button
      class="cta cta--primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="form.invalid || isSubmitting">
      {{ isSubmitting ? 'Enviando...' : 'Guardar' }}
    </button>
  </div>

</div>
